// extracted by mini-css-extract-plugin
export var filterIncDec = "_53-0";
export var leftBorder = "_53-1";
export var rightBorder = "_53-2";
export var stringInput = "_53-3";